import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import React from 'react';
import ja from 'utils/ja';

interface AppModalProps {
  chargerId: string;
  title?: string;
  open: boolean;
  handleClose: () => void;
  content: React.ReactNode;
  actionRightText?: string;
  actionLeftText?: string;
  handleRight?: () => void;
  handleLeft?: () => void;
}

const AppModal: React.FC<AppModalProps> = ({
  title,
  open,
  handleClose,
  content,
  actionRightText = ja.common.ok,
  actionLeftText = ja.common.cancel,
  handleRight,
  handleLeft = handleClose,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth='md'
      open={open}
      onClose={(_, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
          return;
        }
        handleClose();
      }}
      disableEscapeKeyDown
      PaperProps={{
        component: 'div',
        sx: {
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '6px',
          overflowY: 'unset',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '30px',
        }}
      >
        <Typography
          sx={{
            fontWeight: 'bold',
            color: '#333333',
            fontSize: '30px',
            width: '100%',
            textAlign: 'center',
          }}
        >
          {title}
        </Typography>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          alignContent: 'center',
          alignItems: 'center',
          padding: '20px',
          overflowY: 'unset',
        }}
      >
        <Divider sx={{ my: 1, width: '100%', margin: '0 10px 0 10px' }} />
        {content}
        <Box
          sx={{
            width: '95%',
            display: 'flex',
            justifyContent: 'flex-end',
          }}
        >
          <Button
            variant='text'
            sx={{
              fontSize: '30px',
              color: 'primary.main',
            }}
            onClick={handleLeft}
          >
            {actionLeftText}
          </Button>
          <Button
            variant='text'
            sx={{
              fontSize: '30px',
              color: 'primary.main',
            }}
            onClick={handleRight}
          >
            {actionRightText}
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default AppModal;
